<template>
  <div>
    <el-form :label-position="labelPosition" :rules="tmpFormRules" label-width="80px" :model="formLabelAlign">
      <el-form-item label="步骤名称">
        <el-input v-model="formLabelAlign.name" disabled style="width: 360px;"></el-input>
      </el-form-item>
      <el-form-item label="微信账号" prop="wechatPublicId">
        <el-select @change="update" v-model="formLabelAlign.wechatPublicId" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.nick_name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模板消息" prop="messageId">
        <el-select @change="updates" filterable v-model.number="formLabelAlign.messageId" placeholder="请选择">
          <el-option
            v-for="item in formLabelAlign.useList"
            :key="item.id"
            :label="item.message_title"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getTemplateList } from '@/api/customer.js'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      tmpFormRules: {
        wechatPublicId: [
          { required: true, message: '微信账号不能为空', trigger: 'change' }
        ],
        messageId: [
          { required: true, message: '模板消息不能为空', trigger: 'change' }
        ]
      },
      options: [],
      messageList: [],
      labelPosition: 'right',
      formLabelAlign: this.contents,
      choose: {}
    }
  },
  computed: {
  },
  methods: {
    update() {
      for (let i in this.options) {
        if (this.formLabelAlign.wechatPublicId === this.options[i].id) {
          this.formLabelAlign.useList = this.messageList[i]
        }
      }
      this.messageId = ''
    },
    updates() {
      // 传值到父组件
      this.choose.nodeType = 'templateMessageNode'
      this.choose.name = '模板消息'
      this.choose.wechatPublicId = this.formLabelAlign.wechatPublicId
      this.choose.id = this.formLabelAlign.id
      this.choose.useList = this.formLabelAlign.useList
      this.choose.messageId = this.formLabelAlign.messageId
      this.$emit('change', this.choose)
    },
    // 加载公众号列表和模板列表
    loadAll() {
      getTemplateList().then((res) => {
        if (res.data.code === 0) {
          for (let item of res.data.data.list) {
            this.messageList.push(item.message)
          }
          this.options = res.data.data.list
        }
      })
    }
  },
  watch: {
    contents: function (val) {
      this.formLabelAlign = val
    }
  },
  created() {
    this.loadAll()
    console.log('contents', this.formLabelAlign)
  }
}
</script>

<style scoped>

</style>
